<button [type]="type" mat-stroked-button color="warn">
  <ng-content></ng-content>
</button>
